import React, { useState, useEffect } from "react";
import "./surveys.scss";
import { useSurveyUserProfile } from "../../services/surveyUserProfile.service";
import { SideAdvertising } from "../../components/sideAdvertising/sideAdvertising";
import { ListSurveys } from "./listSurveys";
import BoxSurveys from "./boxSurveys";
import Moment from "react-moment";
import "moment/locale/es";
import { useSelector } from "react-redux";
import { AdvertisingSection } from "../../components/advertisingSection/advertisingSection";
import { Col, Row } from "reactstrap";
import { Button } from "rsuite";
import { useCompanyHoliday } from "../../services/companyHoliday.service";
import { BsThreeDots } from "react-icons/bs";
import { FaCheck } from "react-icons/fa";

export function Surveys({ refresh }) {
  // ─── Estados ────────────────────────────────────────────────
  const [asideVisible, setAsideVisible] = useState(false);
  const [tempQuestionsVisible, setTempQuestionsVisible] = useState(false);
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [surveysData, setSurveysData] = useState({
    pendingSurveys: [],
    resolvedSurveys: [],
  });
  const [sliderItems, setSliderItems] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const calendarStrings = useSelector((state) => state.calendarStrings);

  // ─── Efectos ───────────────────────────────────────────────
  useEffect(() => {
    getSurveys();
  }, [refresh]);

  useEffect(() => {
    getCompanyHolidays();
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Ocultar aside automáticamente en pantallas grandes
    if (windowWidth >= 992 && asideVisible) {
      setAsideVisible(false);
    }

    return () => window.removeEventListener("resize", handleResize);
  }, [windowWidth, asideVisible]);

  // Manejo de clase en <body> según estado de preguntas temporales
  useEffect(() => {
    if (tempQuestionsVisible) {
      document.body.classList.add("hide-over");
    } else {
      document.body.classList.remove("hide-over");
    }

    return () => {
      document.body.classList.remove("hide-over");
    };
  }, [tempQuestionsVisible]);

  // ─── Funciones ─────────────────────────────────────────────
  const getSurveys = async () => {
    const result = await useSurveyUserProfile.getSurveysUserProfile();
    if (result) setSurveysData(result);
  };

  const getCompanyHolidays = async () => {
    const result = await useCompanyHoliday.getCompanyHolidayFront(3);
    if (result) {
      const temp = result.map((ch) => ({
        key: ch.companyHolidayId.toString(),
        file: ch.imagePath,
        description: ch.description,
        isVideo: ch.isVideo,
        link: ch.iframe,
      }));
      setSliderItems(temp);
    }
  };

  const toggleAside = () => setAsideVisible((prev) => !prev);
  const toggleTempQuestions = () =>
      setTempQuestionsVisible((prev) => !prev);

  const handleOnSurveySelected = (survey) => {
    setSelectedSurvey(null); // reset
    setSelectedSurvey(survey);
  };

  return (
      <section className="container-page">
        <div className="row justify-content-center mt-4">
          <div className="col-sm-8">
            <AdvertisingSection HolType={9} />
          </div>
        </div>

        <article className="surveys-container">
          <div className="surveys-container-content">
            <Row>
              <Col sm={12}>
                <h2 className="mt-0 mb-2 opi">
                  Tu opinión
                  <Button className="btn-ellipsis-open" onClick={toggleAside}>
                    <BsThreeDots />
                  </Button>
                </h2>

                <div className="border-pointed">
                  <p>
                    Esta encuesta es anónima y personal, lee detenidamente cada
                    ítem, es muy fácil de responder, en la mayoría de las
                    preguntas se pide que elijas entre varias posibilidades.
                  </p>
                </div>
              </Col>
            </Row>

            <div className="surveys-container-content-body">
              <h5 className="mb-3 mt-4">Encuestas disponibles</h5>

              {surveysData.pendingSurveys.length === 0 ? (
                  <p>Por el momento no tienes encuestas pendientes</p>
              ) : (
                  <div className="surveys-list">
                    <ListSurveys
                        surveys={surveysData.pendingSurveys}
                        onSelectSurvey={handleOnSurveySelected}
                        handleTempQuestions={toggleTempQuestions}
                    />
                  </div>
              )}

              <div
                  className={`surveys-card ${
                      tempQuestionsVisible ? "is_show" : ""
                  }`}
              >
                {selectedSurvey && <BoxSurveys survey={selectedSurvey} />}
              </div>
            </div>
          </div>

          <aside className={`surveys-container-aside ${asideVisible ? "is-show" : ""}`}>
            <Button className="btn-ellipsis-close" onClick={toggleAside}>
              <i className="icon-close"></i>
            </Button>

            {sliderItems.length > 0 && <SideAdvertising />}

            <div className="surveys-container-aside-prev">
              <h6>Últimas encuestas realizadas</h6>

              {surveysData.resolvedSurveys.length === 0 ? (
                  <p>Por el momento no tienes encuestas realizadas</p>
              ) : (
                  surveysData.resolvedSurveys.map((survey) => (
                      <div className="item" key={survey.surveyId}>
                  <span>
                    <FaCheck />
                  </span>
                        <div>
                          <div className="xtl_survey">{survey.title}</div>
                          <small>
                            <Moment calendar={calendarStrings}>
                              {survey.modifiedDate}
                            </Moment>
                          </small>
                        </div>
                      </div>
                  ))
              )}
            </div>
          </aside>
        </article>
      </section>
  );
}
